import { FC, SyntheticEvent, useState } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'
import Table from '../../../utils/ResultViewer/Table'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
const TemplatesList: FC = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  return (
    <>
      <Table
        title={intl.formatMessage({ id: 'MENU.TEMPLATES' })}
        dataUrl='/templates/list'
        editCallback={(id: any, refresh: Function) => {
          navigate('/reports/templates/' + id)
        }}
        deleteCallback={(id: any, refresh: Function) => {
          axios.get('/templates/save/' + id).then((response) => {
            let csrfData = response.data.data
            Swal.fire({
              title: 'Warning',
              html: 'Are you want to delete this account?',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Delete',
              cancelButtonText: 'Cancel',
              customClass: {
                confirmButton: 'btn btn-danger',
                cancelButton: 'btn btn-primary',
              },
            }).then((result) => {
              if (result.isConfirmed) {
                axios
                  .delete('templates/save/' + id, {
                    data: csrfData,
                  })
                  .then(() => {
                    refresh()
                  })
              }
            })
          })
        }}
        actionItems={[
          {
            text: intl.formatMessage({ id: 'REPORTS.TEMPLATES.ADDTEMPLATES' }),
            class: 'btn btn-sm btn-primary',
            icon: 'fa fa-plus',
            onClick: function (event: SyntheticEvent, refresh: Function) {
              navigate('/reports/templates/add')
            },
          },
        ]}
      />
    </>
  )
}

export { TemplatesList }
